export default __webpack_public_path__ + "static/media/twitteratis.fc38220b.png";